import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ComandaDetalharJanelaComponent } from './comanda-detalhar-janela.component';


@NgModule({
  imports: [RouterModule.forChild([
    {path:':id', component: ComandaDetalharJanelaComponent}
  ])],
  exports: [RouterModule]
})
export class ComandaDetalharJanelaRoutingModule { }
